module.exports = __webpack_public_path__ + "static/img/networks_bnb.39270cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/networks_bnb.png
// module id = zwC/
// module chunks = 0